import theme from "@monorepo/styles/theme";
import { styled } from "@mui/material/styles";

import citadele from "./logos/citadele.png";
import kevin from "./logos/kevin.png";
import kreda from "./logos/kreda.png";
import lku from "./logos/lku.png";
import luminor from "./logos/luminor.png";
// import luminor_dnb from "./logos/luminor_dnb.png";
import medicinos_bankas from "./logos/medicinos_bankas.png";
import n26 from "./logos/n26.png";
import neopay from "./logos/neopay.png";
import paysera from "./logos/paysera.png";
import perlas from "./logos/perlas.png";
import rato from "./logos/rato.png";
import revolut from "./logos/revolut.png";
import seb from "./logos/seb.png";
import siauliubank from "./logos/siauliubank.png";
import sme from "./logos/sme.png";
import swedbank from "./logos/swedbank.png";
import wise from "./logos/wise.png";

enum BanksEnum {
  CITADELE = "citadele",
  SWEDBANK = "swedbank",
  LKU = "lku",
  MEDICINOS_BANKAS = "medicinos_bankas",
  LUMINOR = "luminor",
  LUMINOR_DNB = "luminor_dnb",
  PAYSERA = "paysera",
  PERLAS = "perlas",
  REVOLUT = "revolut",
  SIAULIU_BANKAS = "siauliu_bankas",
  SEB = "seb",
  KEVIN = "kevin",
  RATO = "rato",
  SME = "sme_bank",
  KREDA = "kreda",
  WISE = "wise",
  N26 = "n26",
  NEOPAY = "neo_finance",
  PASKOLU_KLUBAS = "paskolu_klubas",
}

const StyledImage = styled("img")(() => ({
  width: "35px",
  [theme.breakpoints.up("sm")]: {
    width: "45px",
  },
}));

export const BankLogo = ({ bank }: { bank: string }) => {
  switch (bank) {
    case BanksEnum.KEVIN:
      return <StyledImage src={kevin} alt={bank} />;
    case BanksEnum.CITADELE:
      return <StyledImage src={citadele} alt={bank} />;
    case BanksEnum.SWEDBANK:
      return <StyledImage src={swedbank} alt={bank} />;
    case BanksEnum.LKU:
      return <StyledImage src={lku} alt={bank} />;
    case BanksEnum.MEDICINOS_BANKAS:
      return <StyledImage src={medicinos_bankas} alt={bank} />;
    case BanksEnum.LUMINOR:
      return <StyledImage src={luminor} alt={bank} />;
    case BanksEnum.LUMINOR_DNB:
      return <StyledImage src={luminor} alt={bank} />;
    case BanksEnum.PAYSERA:
      return <StyledImage src={paysera} alt={bank} />;
    case BanksEnum.PERLAS:
      return <StyledImage src={perlas} alt={bank} />;
    case BanksEnum.REVOLUT:
      return <StyledImage src={revolut} alt={bank} />;
    case BanksEnum.SIAULIU_BANKAS:
      return <StyledImage src={siauliubank} alt={bank} />;
    case BanksEnum.SEB:
      return <StyledImage src={seb} alt={bank} />;
    case BanksEnum.RATO:
      return <StyledImage src={rato} alt={bank} />;
    case BanksEnum.SME:
      return <StyledImage src={sme} alt={bank} />;
    case BanksEnum.KREDA:
      return <StyledImage src={kreda} alt={bank} />;
    case BanksEnum.WISE:
      return <StyledImage src={wise} alt={bank} />;
    case BanksEnum.N26:
      return <StyledImage src={n26} alt={bank} />;
    case BanksEnum.NEOPAY:
      return <StyledImage src={neopay} alt={bank} />;
    default:
      return null;
  }
};
